angular.module('unergie.main')
.filter('indexNatureHelp', () => {
    return function (value) {
        switch (value) {
            case 'ARLV':
            case 'AUTO-RELEVE':
            case 'CAIF':
                return 'Relève communiquée par le client'
            case 'CSIF':
            case 'ESTI':
            case 'ESTIME':
                return 'Relève estimée par Enedis (historique compteur)'
            case 'REEL':
                return 'Relève technicien Enedis'
            case 'TRLV':
                return 'Relève transmise par Linky'
            default:
                return value
        }
    }
})
